<template>
  <div class="access-wrapper">
    <div class="card">
      <img
        src="../../assets/img/access-denied.png"
        alt="Access Denied"
        class="illustration"
      >

      <h1 class="text-h6">
        Access Denied
      </h1>

      <p class="subtitle">
        You don’t have permission to access this resource.
        Please contact your administrator or switch organization.
      </p>

      <!-- <div class="actions">
        <v-btn
          color="primary"
          elevation="0"
          @click="goHome"
        >
          Go to Dashboard
        </v-btn>

        <v-btn
          text
          class="ml-2"
          @click="$router.back()"
        >
          Go Back
        </v-btn>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccessDenied',
  methods: {
    goHome () {
      this.$router.push('/');
    },
  },
};
</script>

<style scoped>
.access-wrapper {

  display: flex;
  justify-content: center;
  align-items: center;
}

.card {
  max-width: 420px;
  width: 100%;
  text-align: center;
  padding: 40px 30px;
  border-radius: 16px;
}

.illustration {
  width: 100px;
  margin-bottom: 20px;
}

.title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 10px;
}

.subtitle {
  font-size: 14px;
  color: #777;
  margin-bottom: 25px;
}

.actions {
  display: flex;
  justify-content: center;
  gap: 10px;
}
</style>
